import "./VehiclesContent.scss";

import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useApplyFilters } from "../../../hooks/useApplyFilters";

import { openDrawer } from "../../../slices/drawerSlice";

import { fetchVehicles } from "../../../slices/vehiclesSlice";

import { setShowAlert } from "../../../slices/alertSlice";

import Warning from "@mui/icons-material/Warning";

import { Table } from "../../../common-components/Table/Table";
import { Message } from "../../../common-components/Message/Message";
import { List } from "../../../common-components/List/List";
import { Pagination } from "../../../common-components/Pagination/Pagination";

import VehiclesTools from "../VehiclesTools/VehiclesTools";
import VehiclesDetails from "../VehiclesDetails/VehiclesDetails";

const VehiclesContent = () => {
    const dispatch = useDispatch();
    const componentId = "vehicles";
    const token = useSelector((state) => state.auth.token);
    const columnsFromStore = useSelector((state) => state.vehicles.columns);
    const dataFromStore = useSelector((state) => state.vehicles.data);
    const error = useSelector((state) => state.vehicles.error);
    const meta = useSelector((state) => state.vehicles.meta);
    const hasShownForbidden = useRef(false);
    const { params } = useApplyFilters({componentId});

    console.log(params);

    useEffect(() => {
        if (error?.status === 403) return;

        dispatch(fetchVehicles({ token, params }));
    }, [dispatch, token, params]);

    const columns = useMemo(() => {
        if (!columnsFromStore) return [];
        return columnsFromStore.map(col => ({
            key: col.key,
            header: col.alias || col.name || col.key
        }));
    }, [columnsFromStore]);

    const data = useMemo(() => {
        if (!Array.isArray(dataFromStore)) return [];
        return dataFromStore.map((item) => {
            const attributes = item?.attributes || {};
            return {
                id: item.id,
                ...attributes
            };
        });
    }, [dataFromStore]);

    const handleRowClick = (row) => {
        console.log(row.id);

        dispatch(openDrawer({
            content: <VehiclesDetails id={row.id}/>
        }))
    }

    const renderVehicleTable = () => {
        if (error?.status === 403) {
            return <Message Icon={Warning} description={error.message}/>
        } else {
            return <Table data={data} additionalColumns={columns} onRowClick={handleRowClick}/>
        }
    }

    const renderVehicleMobileList = () => {
        if (error?.status === 403) {
            return <Message Icon={Warning} description={error.message}/>
        } else {
            return <List data={data} clientColumns={columns} onRowClick={handleRowClick}/>
        }
    }

    return (
        <div className={"vehicles-content"}>
            <div className={"vehicles-content_container"}>
                <div className={"vehicles-content_tools"}>
                    <VehiclesTools/>
                </div>
                <div className={"vehicles-content_table"}>
                    {renderVehicleTable()}
                </div>
                <div className={"vehicles-content_list"}>
                    {renderVehicleMobileList()}
                </div>
                <div className={"vehicles-content_pagination"}>
                    <Pagination meta={meta}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesContent;